/**
 * 22×22 rounded chip showing a hit's rank number. Default state is a
 * neutral secondary bg; the highlighted state (for the focused/hover row
 * on a card) swaps to the pink accent.
 */

interface RankChipProps {
  rank: number;
  highlighted?: boolean;
  muted?: boolean;
}

export function RankChip({ rank, highlighted, muted }: RankChipProps) {
  return (
    <div
      style={{
        width: 22,
        height: 22,
        borderRadius: 6,
        background: highlighted ? "var(--atf-pink-600)" : "var(--secondary)",
        color: highlighted ? "white" : muted ? "var(--muted-foreground)" : "var(--foreground)",
        display: "grid",
        placeItems: "center",
        fontFamily: "var(--font-mono)",
        fontSize: 11,
        fontWeight: 600,
        flexShrink: 0,
        border: highlighted ? "none" : "1px solid var(--border)",
      }}
    >
      {rank}
    </div>
  );
}
